import React, { Component } from 'react';
import { Link } from 'gatsby';

import './style.css';

/**
 * Компонент карточки элемента календаря на главной странице.
 * @class
 * @param {Object} props        данные, пришедшие от родителя
 * @param {Object} props.data   массив с данными для карточки календаря
 * @memberof react-router-dom
 */
class CalendarItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            fade: true,
            is_drag: false
        }
    }

    componentDidMount() {
        setTimeout(() => {
            if (this.state.fade === true) {
                this.setState({ fade: false })
            }
        }, 1000);
    }

    componentDidUpdate() {
        //обновляем значение с небольшой задержкой, чтобы ссылка не открывалась после того как отпускаешь кнопку
        if (this.props.is_drag === false && this.state.is_drag === true) {
            setTimeout(() => {
                this.setState({
                    is_drag: false
                })
            }, 100)
        }
    }

    render() {
        return(
            <article className={this.state.fade === true ? "calendar-item__block" : "calendar-item__block calendar-item__block-fadeIn"}>
                {
                    this.props.data.link === undefined ?
                    null :
                    <div className={this.props.data.seats !== undefined && this.props.data.seats === '-' ? "calendar-item__container calendar-item__container_no-seats" : "calendar-item__container"}>
                        <Link className="calendar-item__link" to={"/mc"+this.props.data.link}
                                state={{ date: this.props.data.form_date }}
                                data_date={this.props.data.seats === '-' ? this.props.data.date+' (мест нет)' : this.props.data.date} draggable="true"
                                onClick={(e) => {
                                    //запрет открытия при перетаскивании
                                    if (this.state.is_drag === true) {
                                        e.preventDefault(); 
                                    }
                                }}
                                //дополнительная обработка каждого элемента, чтобы ссылка не открывалась во время перетаскивания
                                onDragStart={e => {
                                    this.setState({
                                        is_drag: true
                                    })
                                    e.stopPropagation();
                                    e.preventDefault();
                                }}>
                            <div className="calendar-item__image" dangerouslySetInnerHTML={{ __html: this.props.data.image === undefined ? null : this.props.data.image}} />
                            <div className="calendar-item-description">
                                <p className="calendar-item-description__time">{this.props.data.time}</p>
                                <h4 className="calendar-item-description__title">{this.props.data.name}</h4>
                                <div className="calendar-item-description__info">
                                    {
                                        this.props.data.price === undefined ?
                                        null :
                                        <p className="calendar-item-description__price">{this.props.data.price}</p>
                                    }
                                    {
                                        this.props.data.seats !== undefined && this.props.data.seats === '-' ?
                                        <p className="calendar-item-description__seats">Мест нет</p>    :
                                        null
                                    }
                                </div>
                            </div>
                        </Link>
                    </div>
                }
            </article>
        )
    }
}

export default CalendarItem;